import { render, staticRenderFns } from "./TwoRowHeader.vue?vue&type=template&id=44ae0fd6&scoped=true"
import script from "./TwoRowHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoRowHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TwoRowHeader.vue?vue&type=style&index=0&id=44ae0fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ae0fd6",
  null
  
)

export default component.exports